var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElements(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 186,
    viewBox: "0 0 84 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 3,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 3,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 3,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 3,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 3,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 21,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 21,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 21,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 21,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 21,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 39,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 39,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 39,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 39,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 39,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 57,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 57,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 57,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 57,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 57,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 75,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 75,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 75,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 75,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 75,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 93,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 93,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 93,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 93,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 93,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 111,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 111,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 111,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 111,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 111,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 129,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 129,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 129,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 129,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 129,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 147,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 147,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 147,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 147,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 147,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 165,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 165,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 165,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 165,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 165,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 183,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 183,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 183,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 183,
    r: 3,
    fill: "#5BC17F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 183,
    r: 3,
    fill: "#5BC17F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElements);
export default __webpack_public_path__ + "static/media/elements.8b5361e20c9e588444f5b3c9e4feab5e.svg";
export { ForwardRef as ReactComponent };